import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { navItems } from "../data/content";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const slug = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  const linkClass = ({ isActive }) =>
    `whitespace-nowrap text-sm font-semibold transition-colors ${isActive ? "text-[#0066FF]" : "text-[#0A2540] hover:text-[#0066FF]"}`;

  return (
    <header className="fixed top-0 z-50 w-full border-b border-[#E2E8F0] bg-white/80 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-4 md:px-8">
        <Link to="/" className="group flex items-center gap-3" data-testid="site-logo-link" onClick={() => setOpen(false)}>
          <span className="grid h-10 w-10 shrink-0 place-items-center bg-[#0A2540] text-sm font-black text-white transition-transform group-hover:-translate-y-0.5">TB</span>
          <span className="min-w-0 leading-tight">
            <span className="block truncate font-heading text-base font-black text-[#0A2540] sm:text-lg">TalentBridge</span>
            <span className="block truncate text-[10px] font-semibold uppercase tracking-[0.16em] text-[#64748B] sm:text-xs">Consulting</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-5 lg:flex" aria-label="Main navigation">
          {navItems.map((item) => (
            <NavLink key={item.path} to={item.path} className={linkClass} data-testid={`nav-${slug(item.label)}-link`}>
              <span className="inline-flex items-center gap-2">
                {item.label}
                {item.isFree && <span className="bg-emerald-600 px-2 py-0.5 text-[10px] font-black uppercase tracking-[0.12em] text-white" data-testid={`nav-${slug(item.label)}-free-badge`}>Free</span>}
                {item.isNew && <span className="bg-[#0066FF] px-2 py-0.5 text-[10px] font-black uppercase tracking-[0.12em] text-white" data-testid={`nav-${slug(item.label)}-new-badge`}>New</span>}
              </span>
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <Link to="/admin" className="text-sm font-bold text-[#0A2540] hover:text-[#0066FF]" data-testid="nav-admin-link">
            Admin
          </Link>
          <Link to="/booking" className="inline-flex items-center gap-2 bg-[#0A2540] px-5 py-3 text-sm font-bold text-white transition-transform hover:-translate-y-0.5 hover:bg-[#051424]" data-testid="nav-booking-cta-link">
            Book consult <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <button
          type="button"
          className="z-[60] grid h-11 w-11 shrink-0 place-items-center border border-[#E2E8F0] bg-white text-[#0A2540] shadow-sm lg:hidden"
          onClick={() => setOpen((value) => !value)}
          aria-label="Toggle navigation menu"
          aria-expanded={open}
          data-testid="mobile-menu-toggle-button"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-[#E2E8F0] bg-white px-5 py-5 lg:hidden" data-testid="mobile-menu-panel">
          <div className="mx-auto flex max-w-7xl flex-col gap-4">
            {navItems.map((item) => (
              <NavLink key={item.path} to={item.path} className={linkClass} onClick={() => setOpen(false)} data-testid={`mobile-nav-${slug(item.label)}-link`}>
                <span className="inline-flex items-center gap-2">
                  {item.label}
                  {item.isFree && <span className="bg-emerald-600 px-2 py-0.5 text-[10px] font-black uppercase tracking-[0.12em] text-white" data-testid={`mobile-nav-${slug(item.label)}-free-badge`}>Free</span>}
                  {item.isNew && <span className="bg-[#0066FF] px-2 py-0.5 text-[10px] font-black uppercase tracking-[0.12em] text-white" data-testid={`mobile-nav-${slug(item.label)}-new-badge`}>New</span>}
                </span>
              </NavLink>
            ))}
            <NavLink to="/admin" className={linkClass} onClick={() => setOpen(false)} data-testid="mobile-nav-admin-link">
              Admin
            </NavLink>
          </div>
        </div>
      )}
    </header>
  );
}